<footer id="footer" class="footer" role="contentinfo">
    <div class="container">
        <div class="container__inner is-flex">
            <div class="column is-one-fifth-desktop padding-bottom--base-half align-self--center">
                <a href="https://www.riege.com" class="footer__logo" target="_blank">
                    <img
                        i18n-alt="@@footer-logo-alt"
                        alt="Riege Software Logo, back to homepage"
                        src="assets/logo-riege-footer.svg" />
                </a>
            </div>

            <div class="column is-one-fifths-tablet is-right">
                <span *ngIf="!authService.isLoggedIn()" class="footer__link">
                    <app-language-switch position="above"></app-language-switch>
                </span>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="container__inner">
            <mat-divider></mat-divider>
        </div>
    </div>

    <div class="container">
        <div class="container__inner is-flex--desktop is-align-items-center">
            <ng-container *ngIf="isMobile()">
                <mat-accordion>
                    <mat-expansion-panel class="mat-elevation-z0">
                        <mat-expansion-panel-header>
                            <mat-panel-title i18n="@@footer-title-legal-texts"> Legal texts </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngTemplateOutlet="legal"></div>
                    </mat-expansion-panel>
                </mat-accordion>
            </ng-container>

            <ng-container *ngIf="!isMobile()">
                <div class="column is-full-desktop padding-top--base-half padding-bottom--base-half">
                    <div *ngTemplateOutlet="legal"></div>
                </div>
            </ng-container>

            <ng-template #legal>
                <div class="footer__link">
                    <a href="{{ linkImprint }}" target="_blank" i18n="@@footer-link-imprint">Imprint</a>
                </div>
                <div class="footer__link">
                    <a href="{{ linkPrivacy }}" target="_blank" i18n="@@footer-link-privacy">Privacy</a>
                </div>
                <div class="footer__link">
                    <a href="{{ linkTerms }}" target="_blank" i18n="@@footer-link-terms">Terms</a>
                </div>
                <div class="footer__link">
                    <a href="{{ linkTermsUS }}" target="_blank" i18n="@@footer-link-terms-us">Terms US</a>
                </div>
                <div class="footer__link" *ngIf="showMatomoConsent">
                    <a href="#" (click)="manageCookies($event)" i18n="@@footer-link-consent">Manage cookies</a>
                </div>
            </ng-template>
        </div>
    </div>

    <div class="container">
        <div class="container__inner">
            <mat-divider></mat-divider>
        </div>
    </div>

    <div class="container">
        <div class="container__inner is-flex">
            <div class="column is-four-fifths">
                <a href="https://www.riege.com" target="_blank">
                    &copy; {{ currentDate }} Riege Software International GmbH
                </a>
            </div>

            <div class="column is-one-fifths is-right">
                <span i18n="@@footer-version">Version</span>: {{ version }}
            </div>
        </div>
    </div>
</footer>
